/* Restructures the two frontpage tiers: cards get wrapped in .mcw-track
   (the horizontal scroller) inside .mcw-trackwrap (arrow overlay host),
   while the section heading stays outside as a frozen column. */
(function () {
  function addArrows(wrap, track) {
    var bar = document.createElement('div');
    bar.className = 'mcw-tile-arrows';
    ['‹', '›'].forEach(function (ch, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = ch;
      b.setAttribute('aria-label', i ? 'Scroll right' : 'Scroll left');
      b.addEventListener('click', function () {
        track.scrollBy({ left: (i ? 1 : -1) * track.clientWidth * 0.8, behavior: 'smooth' });
      });
      bar.appendChild(b);
    });
    wrap.appendChild(bar);
  }
  function arm(id) {
    var host = document.getElementById(id);
    if (!host || host.classList.contains('mcw-ready')) return;
    var wrap = document.createElement('div');
    wrap.className = 'mcw-trackwrap';
    var inner = host.querySelector(':scope > .row.center');
    var track;
    if (inner) {
      // occasions shape: heading + nested cards row — the row becomes the track
      track = inner;
      host.insertBefore(wrap, inner);
      wrap.appendChild(inner);
    } else {
      // personas shape: heading and cards are siblings — collect the cards
      track = document.createElement('div');
      [].slice.call(host.children).forEach(function (c) {
        if (c.tagName === 'STYLE' || c.classList.contains('section__heading')) return;
        track.appendChild(c);
      });
      wrap.appendChild(track);
      host.appendChild(wrap);
    }
    track.classList.add('mcw-track');
    track.scrollLeft = 0;
    addArrows(wrap, track);
    host.classList.add('mcw-ready');
  }
  function init() { arm('frontpage-personas'); arm('frontpage-occasions'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else setTimeout(init, 200);
})();
